import { Box } from '@material-ui/core';
import React from 'react';

import { useCustomTheme } from '../../../../hooks/useCustomTheme';
import { Font } from '../../../shared/components/Font';

export const NotificationNumberCircle = ({ num }) => {
  const { palette } = useCustomTheme();
  return (
    <Box
      style={{
        backgroundColor: palette.error.main,
        color: palette.error.contrastText,
        display: 'inline-block',
        padding: '1px 4px',
        borderRadius: '20px',
        textAlign: 'center',
        minWidth: '10px',
        lineHeight: '8px',
        height: 'fit-content',
        minHeight: '10px',
      }}
    >
      <Font variant={'caption'}>{num}</Font>
    </Box>
  );
};
